import Props from './types';
import S from './DriverStyles';
import ImageWithFallback from '../../ImageWithFallback/ImageWithFallback';

function Driver({
  imageSrc,
  name,
  licenseName,
}: Props):JSX.Element {
  return (
    <S.Wrapper>
      <div className="avatar">
        <ImageWithFallback src={imageSrc} alt="driver" />
      </div>
      <div className="description">
        <p className="name" title={name}>{name}</p>
        <p className="licenseName" title={licenseName}>{licenseName}</p>
      </div>
    </S.Wrapper>
  );
}

export default Driver;
